<template>
    <div>
        <!-- Modal -->
        <div id="renameResource" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Rename File</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0" for="name">Name</label>
                            <input v-model="updateResourceFile.name" id="name" name="name" maxlength="15"
                                   class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="updateFileName(updateResourceFile.id)"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>

            </div>
        </div>


        <div id="fileFolderModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Move file to:</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)" @submit.prevent>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="name"
                                       :class="{'text-red': form.errors.has('name')}">Folder</label>
                                <select v-model="form.folder_id"
                                        class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full">
                                    <option v-for="folder in folders" :key="folder.id" :value="folder.id">{{ folder.name }}</option>
                                </select>
                                <div class="text-red text-xs" v-if="form.errors.has('name')">{{ form.errors.get('folder') }}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="move"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <flash-message></flash-message>
        <div v-show="!clean">
            <div v-if="project" class="text-2xl text-grey-darkest mb-4">Project Resources - {{ folder ? folder.name : '' }}</div>
            <div v-else-if="company" class="text-2xl text-grey-darkest mb-4">Client Resources</div>
            <div v-else class="text-2xl text-grey-darkest mb-4">Resources</div>
            <div v-if="this.company || this.project" class="text-teal hover:text-teal-dark font-base text-sm mb-4">
                <div @click="goBack" class="flex cursor-pointer">
                    <span class="material-icons">chevron_left</span>
                    <span>Back</span>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap flex-lg-nowrap">
            <div v-show="hasOneFile || !clean" class="w-1/4 mr-4 hidden lg:inline">
                <file-pond
                    name="test"
                    ref="pond"
                    label-idle="Drop multiple files anywhere on the page..."
                    allow-multiple="true"
                    :server="server"
                    :onprocessfile="handleOnProcessFile"
                    :onaddfilestart="handleOnAddFileStart"
                    dropOnPage="true"
                    dropOnElement="false"
                />
            </div>
            <div class="w-full mb-4 lg:hidden">
                <input type="file" @change="uploadFile" id="responsive-file-input" ref="responsiveFileInput"
                       class="btn btn-primary col-12 lg:hidden" multiple>
            </div>
            <div class="flex-1">
                <div v-if="stack && resourceFiles.length > 0" @click.stop.prevent="uploadToStack()" class="pointer hover:bg-grey-lighter mx-1 change_text_color">
                    Upload to STACK <i class="fa fa-upload pl-2"></i>
                </div>
                <!--<div v-if="companyCam && resourceFiles.length > 0" @click.stop.prevent="uploadToCompanyCam()" class="pointer hover:bg-grey-lighter mx-1 change_text_color">
                    Upload to Company Cam <i class="fa fa-upload pl-2"></i>
                </div>-->
                <div class="flex justify-content-end">
                    <a @click.stop.prevent="changeView('grid')" class="mx-1" href="#">
                        <i class="fa fa-th-large"></i>
                    </a>
                    <a @click.stop.prevent="changeView('list')" class="mx-1" href="#">
                        <i class="fa fa-list"></i>
                    </a>
                </div>
                <div v-if="resourceFiles.length > 0" class="bg-white shadow-md rounded mb-6">
                    <table class="text-left w-full border-collapse" v-if="displayType == 'list'">
                        <thead>
                        <tr>
                            <th class="py-2 px-6 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                Name
                            </th>
                            <th class="py-2 px-6 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">
                                Date
                            </th>
                            <th class="bg-grey-lightest border-b border-grey-light" colspan="2"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr @click="download(resourceFile)" class="hover:bg-grey-lighter cursor-pointer border-b-1"
                            v-for="resourceFile in resourceFiles">
                            <td class="text-xs pl-4 py-2 hidden md:table-cell">
                                <div class="text-sm hidden md:table-cell">{{ resourceFile.name }}</div>
                            </td>
                            <td class="text-xs pl-4">
                                <div>{{ resourceFile.date }}</div>
                            </td>
                            <td v-show="!!folders" class="text-right pr-4">
                                <button @click.stop="form.resource_id = resourceFile.id; openModal()"
                                        class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none"
                                        data-toggle="modal" data-target="#fileFolderModal">
                                    folder
                                </button>
                            </td>
                            <td class="text-right pr-4">
                                <button @click.stop="edit(resourceFile)"
                                        class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none">
                                    edit
                                </button>
                                <button @click.stop="destroy(resourceFile)"
                                        class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none">
                                    delete
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div v-if="displayType == 'grid'" class="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-xl-5 p-3">

                        <div
                            @click="download(resourceFile)"
                            class="hover:bg-grey-lighter cursor-pointer col md-4 d-flex"
                            v-for="resourceFile in resourceFiles"
                            :key="resourceFile.id_key">
                            <div class="card w-100 my-2">
                                <div class="resource-files-thumb">
                                    <img :src="resourceFile.thumb_url"
                                        class="card-img-top"
                                        :class="!resourceFile.is_thumb_loaded && 'hidden'"
                                        alt=""
                                        :ref="resourceFile.id"
                                        @error='loadThumbnail'
                                        @load="() => finishLoadThumbnail(resourceFile)"
                                        :data-base_url="resourceFile.thumb_url"/>

                                        <div
                                            class="spinner-border"
                                            role="status"
                                            :class="resourceFile.is_thumb_loaded && 'hidden'">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                </div>
                                <div class="card-body">
                                    <div class="text-xs">
                                        {{ resourceFile.name }}
                                    </div>
                                </div>

                                <div class="text-xs px-1 card-footer d-flex justify-content-between">
                                    <div>{{ resourceFile.date }}</div>
                                    <div class="text-right">
                                        <button @click.stop="edit(resourceFile)"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none">
                                            edit
                                        </button>
                                        <button @click.stop="destroy(resourceFile)"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none">
                                            delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
                    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                </div>
                <div v-else class="mt-10 text-center">
                    <div class="flex-col">
                        <div>
                            <img width="350" src="/images/drop-files.svg">
                        </div>
                        <div class="mt-4">
                            <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                                <div class="text-xl w-1/4 tracking-wide"><span class="hidden lg:inline">Drop a document anywhere on the screen to add
                                    to the company resources!</span>
                                    <span class="lg:hidden">Select a file to add to the company resources!</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="pagination.meta.last_page > 1" class="flex justify-center">
                    <ul class="flex list-reset border border-grey-light rounded w-auto font-sans bg-white">
                        <li v-if="pagination.meta.current_page > 1">
                            <button @click="goToPage(pagination.meta.current_page - 1)"
                                    class="focus:outline-none no-underline block hover:text-white hover:bg-teal-dark text-teal border-r border-grey-light px-3 py-2">
                                Previous
                            </button>
                        </li>
                        <li v-for="(index) in pagination.meta.last_page">
                            <button @click="goToPage(index)" :class="{
                        'bg-teal text-white' : pagination.meta.current_page === index,
                        'text-teal' : pagination.meta.current_page !== index,
                        'border-r' : index !== pagination.meta.last_page
                        }"
                                    class="focus:outline-none no-underline block hover:text-white hover:bg-teal-dark border-grey-light px-3 py-2">
                                {{ index }}
                            </button>
                        </li>
                        <li v-if="pagination.meta.last_page > pagination.meta.current_page">
                            <button @click="goToPage(pagination.meta.current_page + 1)"
                                    class="focus:outline-none no-underline block hover:text-white hover:bg-teal-dark text-teal px-3 py-2 border-l border-grey-light">
                                Next
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vueFilePond from 'vue-filepond';
    import 'filepond/dist/filepond.min.css';
    import Form        from "../../utils/form";
    import axios       from "axios";

    let token = document.head.querySelector('meta[name="csrf-token"]');
    const FilePond = vueFilePond();

    export default {
        components: {FilePond},
        props     : ['company', 'project', 'isPm', 'folder', 'clean', 'folders', 'stack', 'companyCam'],

        data() {
            return {
                displayType: 'grid',
                updateResourceFile: {},
                resourceFiles: [],
                revertedResources: [],
                data_loading: false,
                hasOneFile: false,
                pagination: {
                    data: [],
                    meta: {},
                    links: {},
                },
                server: {
                    revert: (uniqueFileId, load, error) => {
                        let file = JSON.parse(uniqueFileId).resource;
                        this.revertedResources.push(file.token);
                        axios.delete(route('api.resource-files.destroy', {resourceFile: file.token}))
                            .catch((err) => error(err.response.message));
                        load();
                    },
                    process: (fieldName, file, metadata, load, error, progress) => {
                        const formData = new FormData();
                        if (this.company) formData.append('company_id', this.company);
                        if (this.project) formData.append('project_id', this.project);
                        if (this.folder) formData.append('directory_id', this.folder.id);
                        formData.append(fieldName, file, file.name);

                        const request = new XMLHttpRequest();
                        request.open('POST', '/api/resource-files');
                        request.setRequestHeader('X-CSRF-TOKEN', token.content);

                        request.upload.onprogress = (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload = function () {
                            if (request.status >= 200 && request.status < 300) {
                                load(request.responseText);
                            } else {
                                error('oh no');
                            }
                        };

                        request.send(formData);
                    }
                },
                form: new Form({
                    folder_id: this.folder ? this.folder.id : null,
                    resource_id: null,
                }),
            };
        },

        created() {

            this.fetchData();
        },

        methods: {
            async uploadToStack(){
                const self = this;
                await axios.post(route('resource-files.upload-stack'),{
                    project_id: this.project,
                    folder_id: this.folder.id
                }).then((res) =>{
                    self.flash(res.data.message, res.data.status);
                }).catch((err)=>{
                    console.log('err',err)
                })
            },
            async uploadToCompanyCam(){
                const self = this;
                await axios.post(route('resource-files.upload-company-cam'),{
                    project_id: this.project,
                    folder_id: this.folder.id
                }).then((res) =>{
                    self.flash(res.data.message, res.data.status);
                }).catch((err)=>{
                    console.log('err',err)
                })
            },
            loadThumbnail(event) {
                const img = event.target;
                const base_url = img.dataset.base_url;
                setTimeout(() => {img.src = base_url + '?' + new Date();}, 5000);
            },
            finishLoadThumbnail(resourceFile) {
                if (!resourceFile.is_thumb_loaded) {
                    resourceFile.is_thumb_loaded = true;
                    resourceFile.id_key += 'a';
                }
            },
            fetchData() {
                let params = {
                    filter: this.filter,
                    page: this.page,
                    company_id: this.company,
                    project_id: this.project,
                    folder_id: this.folder ? this.folder.id : null,
                };

                this.data_loading = true;
                axios.get(route('api.resource-files.index'), {params}).then(({data}) => {
                    this.resourceFiles = data.data.map(resourceFile => {
                        resourceFile.thumb_url = route('resource-files.show-thumb', {resourceFile: resourceFile.token});
                        resourceFile.is_thumb_loaded = false;
                        resourceFile.id_key = resourceFile.id;

                        return resourceFile;
                    });
                    this.hasOneFile = this.resourceFiles.length > 0;
                    this.pagination = data;
                    this.data_loading = false;
                });
            },

            download(resourceFile) {
                window.open(route('resource-files.show', {resourceFile: resourceFile.token}), '_blank');
            },

            handleOnProcessFile(error, resourceFile) {
                setTimeout(() => {
                    this.$refs.pond.removeFile(resourceFile.id);
                    if (!resourceFile.serverId) return;
                    let file = JSON.parse(resourceFile.serverId).resource;
                    if (this.revertedResources.includes(file.token)) return;
                    file.thumb_url = route('resource-files.show-thumb', {resourceFile: file.token});
                    file.id_key = file.id;
                    this.resourceFiles.unshift(file);
                    this.hasOneFile = this.resourceFiles.length > 0;
                }, 2000);
            },

            handleOnAddFileStart() {
                this.hasOneFile = true;
            },

            async uploadFile() {
                let files = this.$refs.responsiveFileInput.files;
                if (files) {
                    let i = 0;
                    for (i; i < files.length; i++) {
                        const formData = new FormData();

                        if (this.company) formData.append('company_id', this.company);
                        if (this.project) formData.append('project_id', this.project);
                        if (this.folder)  formData.append('directory_id', this.folder.id)
                        formData.append('test', files[i]);
                        await axios.post('/api/resource-files', formData).catch(err => {
                            window.Swal.fire({
                                title: "An error occurred!",
                                text: "The file could not be uploaded!",
                                buttons: true,
                            });
                        });
                    }
                    window.location.reload();
                }
            },

            destroy(resourceFile) {
                let self = this;
                Swal.fire({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this resource!",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'I\'m sure!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then((result) => {
                    if (result.value) {
                        axios.delete(route('api.resource-files.destroy', {resourceFile: resourceFile.token})).then(() => {
                            self.fetchData();
                        }).catch(error => {
                            if (error.response.status === 403 && this.project) {
                                self.flash('Files can only be deleted by users involved on the project, managers or above.', 'error');
                            } else if (error.response.status === 403) {
                                self.flash('Files can only be deleted by managers or above.', 'error');
                            }
                        });
                    }
                });
            },

            edit(resourceFile) {
                this.updateResourceFile = resourceFile;
                $("#renameResource").modal("show");
            },

            updateFileName(resourceFile){
                let self = this;
                axios.put(route('api.resource-files.update', {resourceFile: resourceFile}), {name: self.updateResourceFile.name})
                    .then(function (response) {
                        $("#renameResource").modal("hide");
                        self.flash(response.data.message, 'success');
                    }).catch(error => {
                    if (error.response.status === 403 && this.project) {
                        self.flash('Files can only be edited by users involved on the project, managers or above.', 'error');
                    } else if (error.response.status === 403) {
                        self.flash('Files can only be edited by managers or above.', 'error');
                    }
                });
            },

            goToPage(page) {
                this.page = page;
                this.fetchData();
            },

            goBack() {
                window.location = this.company ? route('company.show', {company: this.company}) : route(`${this.isPm ? 'project-management.' : ''}project.resource-files.folders`, {project: this.project});
            },

            move() {
                this.form.put(route('api.resource-files.move')).then((data) => {
                    Bus.$emit('resourceMoved', {folderId: data.folder_id});
                    $("#fileFolderModal").modal("hide");
                    this.fetchData();
                });
            },

            openModal() {
                $('#fileFolderModal').modal('show');
            },

            changeView(view) {
                this.displayType = view;
            }
        },
    }
</script>
<style scoped>
.change_text_color:hover{
    color: #0f74a8;
    text-decoration: underline;
}

</style>
